import React from "react";

import CurrentDataSelector from "./CurrentDataSelector";
import UrlList from "./UrlList";
import DataSelectors from "./DataSelectors";

import styles from "./styles.module.scss";

const SelectorsBlock = () => (
    <div className={styles.selectorsBlock}>
        <DataSelectors />

        <CurrentDataSelector />

        <UrlList />
    </div>
);

export default SelectorsBlock;
